import { APP_INITIALIZER, inject, Provider } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { ToastService } from '@core/services';
import {
  clearStaleBundleReloadAttempts,
  handleStaleBundleError,
  installStaleBundleGlobalListener,
  shouldClearStaleBundleReloadAttempts
} from '@core/utils/bundle-update.utils';

/** Registra listener globali e reset anti-loop su navigazione riuscita. */
export function provideStaleBundleRecovery(): Provider {
  return {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: () => {
      const toastService = inject(ToastService);
      const router = inject(Router);

      installStaleBundleGlobalListener(() => handleStaleBundleError(toastService));

      router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => {
          if (shouldClearStaleBundleReloadAttempts(event.urlAfterRedirects)) {
            clearStaleBundleReloadAttempts();
          }
        });

      return () => undefined;
    }
  };
}
